export function makeCanonicalUrl(
  host: string,
  zoneName?: string,
  tariff?: string,
): string {
  const prefix = /(http(s?)):\/\//i.test(host) ? '' : 'https://'
  const normalizedHost = host.replace(/\/+$/, '')

  // Канонический URL всегда в форме «услуга + город»: /order/{тариф}/{город}/.
  // Города в начале (/order/{город}/{тариф}/) остаются рабочими и канонизируются
  // в эту же форму — порядок сегментов в роуте не строгий (expressNormalizeParams).
  // ndd_self_pickup и ndd_shipment ведут на /order/: собственных текстов у них нет,
  // ключи в танкерном кейсете order-seo не заведены.
  // russia у cargo_intercity — не город, поэтому схлопывается в /order/cargo-intercity/.

  let path = '/order/'

  switch (tariff) {
    case 'express': {
      path = `/order/express/${zoneName ? `${zoneName}/` : ''}`
      break
    }
    case 'ndd_self_pickup':
    case 'ndd_shipment': {
      path = '/order/'
      break
    }
    case 'cargo': {
      path = `/order/cargo/${zoneName ? `${zoneName}/` : ''}`
      break
    }
    case 'cargo_intercity': {
      const city = zoneName && zoneName !== 'russia' ? zoneName : undefined
      path = `/order/cargo-intercity/${city ? `${city}/` : ''}`
      break
    }
    case 'walking_courier':
    default: {
      path = `/order/${zoneName ? `${zoneName}/` : ''}`
    }
  }

  return `${prefix}${normalizedHost}${path}`
}
